<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
import TnkcBanner from '@/assets/tnkc-banner.png';

export default {
  name: "ActiveHotels",
  data() {
    return {
      tnkcBanner: TnkcBanner,
    };
  },
}
</script>

<style scoped>

</style>